export const getRequiredAttachments = (consultation) => {
    var _a;
    if (!consultation)
        return [];
    return ((_a = consultation.attachments) !== null && _a !== void 0 ? _a : []).filter((a) => a && a.type === 'attachment_requirement');
};
export const getRequiredLabAttachments = (consultation) => {
    return getRequiredAttachments(consultation).filter((ra) => !ra.required_attachment_type || ra.required_attachment_type === 'lab_results');
};
export const getRequiredLabItemNames = (consultation) => {
    return getRequiredLabAttachments(consultation).flatMap((r) => r.item_names || []);
};
export const hasRequiredAttachments = (consultation) => {
    return getRequiredLabAttachments(consultation).length > 0;
};
export const anyRequiredVerified = (consultation) => {
    return getRequiredLabAttachments(consultation).some((r) => !!r.verified);
};
export const hasUploadedAttachments = (consultation) => {
    var _a;
    return ((_a = consultation === null || consultation === void 0 ? void 0 : consultation.attachments) !== null && _a !== void 0 ? _a : []).some((a) => a.type === 'lab_results');
};
